import { BillingTerm } from '../../products/constants/billing-term.enum';
import { OfferListFilter } from '../constants/offer-list-filter.enum';
import { OfferView } from '../constants/offer-view.enum';

export const isOfferListFilter = (value: string | null): value is OfferListFilter => Object.values<string | null>(OfferListFilter).includes(value);

export const isOfferView = (value: string | null): value is OfferView => Object.values<string | null>(OfferView).includes(value);

export const isBillingTerm = (value: string | null): value is BillingTerm => Object.values<string | null>(BillingTerm).includes(value);
